<template>
    <footer class="relative w-full bg-view-sand-light py-16 flex flex-col justify-center gap-16 items-center z-20">
        <div class="flex flex-col gap-16 place-content-between container">
            <h1 class="view-h1 w-full !col-start-1 col-span-2" :class="{'view-h2 !text-[38px]': mainStore.active_locale === 'nl_NL'}">{{ t('title')}}</h1>

            <div class="flex flex-col gap-4  w-full md:col-start-4 col-span-2">
                <h3 class="view-h3">{{ t('visit-us') }}</h3>
                <div class="flex flex-col gap-0">
                    <div>Zeeburgerpad 5</div>
                    <div>1018 AH Amsterdam</div>
                    <div>Netherlands</div>
                </div>
                <a href="https://maps.app.goo.gl/7KmPVywVj6Fk9gYS6" class="underline">{{ t('directions') }}</a>
            </div>

            <div class="flex flex-col gap-16 md:gap-x-4 w-full md:col-start-7 col-end-13 md:grid md:!grid-cols-6">
                    <div class="flex flex-col gap-4 md:!col-start-1 md:col-span-3 w-full">
                        <h3 class="view-h3">{{ t('contact-us') }}</h3>
                        <div class="flex flex-col gap-0 underline">
                            <a href="tel:+31208202348">+31 (0)20 820 2348</a>
                            <a href="mailto:info@yipp.nl">info@yipp.nl</a>
                        </div>
                    </div>

                    <div class="flex flex-col gap-4 md:!col-start-4 md:col-span-3">
                        <h3 class="view-h3">{{ t('follow-us') }}</h3>
                        <div class="flex flex-row gap-4">
                            <a href="https://nl.linkedin.com/company/yipp-interactive" target="_blank" class="w-12 h-12"><LinkedInIcon class="w-full h-full"/></a>
                            <a href="https://www.instagram.com/yippinteractive/" target="_blank" class="w-12 h-12"><InstagramIcon class="w-full h-full"/></a>
                            <a href="https://www.youtube.com/@yippinteractive" target="_blank" class="w-12 h-12"><YoutubeIcon class="w-full h-full"/></a>
                        </div>


                </div>

                <div class="flex flex-col gap-4 col-span-full">
                    <h3>{{ t('newsletter.title') }}</h3>
                    <newsletter-signup />
                </div>


            </div>
        </div>


        <div class="text-center text-dark-blue/50 md:-my-8 text-sm">Copyright © YIPP {{ new Date().getFullYear() }}</div>
    </footer>
</template>

<script setup lang="ts">
import NewsletterSignup from "~/components/view/NewsletterSignup.vue"
import LinkedInIcon from "~/components/icons/LinkedInIcon.vue"
import YoutubeIcon from "~/components/icons/YoutubeIcon.vue"
import InstagramIcon from "~/components/icons/InstagramIcon.vue"

const { t } = useI18n({useScope: 'local'})
const mainStore = useMainStore()
</script>

<i18n lang="yaml">
en:
    title: Want to say hi?
    visit-us: Visit us
    contact-us: Contact us
    follow-us: Follow us
    directions: Get directions
    newsletter:
        title: Sign up for our newsletter
        button: Send
nl:
    title: "Even kennis\nmaken?"
    visit-us: Kom langs
    contact-us: Contact
    follow-us: Volg ons
    directions: Routebeschrijving
    newsletter:
        title: Schrijf je in op onze nieuwsbrief
        button: Verstuur
</i18n>
